import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/** Neutral draw color for the middle tally + bar segment. */
export const DRAWS_BAR_BG = '#3A4658';

export function getMatchHubH2HSummaryHeaderStyles(theme: Theme) {
  return StyleSheet.create({
    tallyRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginBottom: theme.spacing.lg,
    },
    tallyColRight: {
      alignItems: 'flex-end',
    },
    tallyColCenter: {
      alignItems: 'center',
    },
    tallyNumber: {
      fontSize: 34,
      fontWeight: '800',
      letterSpacing: -0.5,
      fontVariant: ['tabular-nums'],
    },
    tallyLabel: {
      fontSize: 11,
      fontWeight: '600',
      color: theme.gray[500],
      marginTop: 4,
    },
    barTrack: {
      flexDirection: 'row',
      height: 8,
      borderRadius: 4,
      overflow: 'hidden',
      backgroundColor: theme.background.inset,
    },
    barSeg: {
      height: '100%',
    },
    barSegDraws: {
      backgroundColor: DRAWS_BAR_BG,
    },
    goalsRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: theme.spacing.md,
    },
    goalsNumber: {
      fontSize: 20,
      fontWeight: '800',
      color: theme.accent,
      fontVariant: ['tabular-nums'],
    },
  });
}
